import { Stack } from "@mui/material";
import { APP_V2_USER_EVENTS, logEvent } from "@src/appV2/lib/analytics";
import { openZendeskMessaging } from "@src/appV2/lib/ZendeskMessaging/openZendeskMessaging";
import { BottomSheetHeader } from "@src/appV2/redesign/components/BottomSheetHeader";
import { Button } from "@src/appV2/redesign/components/Button";
import { DialogFooter } from "@src/appV2/redesign/components/DialogFooter";
import { BottomSheet, type UseModalState } from "@src/appV2/redesign/system/ui-components";
import { useCallback } from "react";

interface SentHomeRequestOptionsBottomSheetProps {
  modalState: UseModalState;
  shiftId: string;
}

export function SentHomeRequestOptionsBottomSheet(props: SentHomeRequestOptionsBottomSheetProps) {
  const { modalState, shiftId } = props;

  async function handleChatWithSupport() {
    logEvent(APP_V2_USER_EVENTS.SENT_HOME_REQUEST_OPTIONS_CHAT_WITH_SUPPORT_TAPPED, { shiftId });
    await openZendeskMessaging();
    modalState.closeModal();
  }

  const handleClose = useCallback(() => {
    modalState.closeModal();
  }, [modalState]);

  return (
    <BottomSheet
      footer={<DialogFooter orientation="vertical" />}
      header={<BottomSheetHeader onClose={handleClose} />}
      modalState={modalState}
    >
      <Stack
        sx={{
          paddingTop: 6,
          paddingX: 4,
        }}
      >
        <Stack spacing={4}>
          <Button
            fullWidth
            variant="outlined"
            size="large"
            startIconType="text-bubble"
            onClick={() => {
              void handleChatWithSupport();
            }}
          >
            Chat with support
          </Button>
        </Stack>
      </Stack>
    </BottomSheet>
  );
}
